export default "__VITE_ASSET__CtT9kg$o__"